import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './ModificaDatiCase.scss';
import useSimpleCaseData from "../../../../hooks/useSimpleCaseData";

const ModificaDatiCase = () => {
  const {data, blockCaseIfNoContract} = useSimpleCaseData();
  return (
    <div className="ModificaDatiCase" data-testid="ModificaDatiCase">
      <CaseGenerator
        type={CaseForms.ModificaDati}
        initialValues={data}
        blockIfNoContracts={blockCaseIfNoContract}
      />
    </div>
  );
};
export default ModificaDatiCase;
